import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Divider, Form, Input, Row, Select } from "antd";
import * as catDuck from "../../../redux/aspirante/catalogoDucks";
//utils
import * as maxValue from "../../../utils";
import { CP, DIRECCION, REQUERIDO, TELEFONO } from "../../../utils";
import { AlertGeneric, Label } from "../../../utils";
import { INFO_TEL, INFO_TEL_10 } from "../../../utils";

//Props de inputs
const props = {
  autoComplete: "off",
};

/**
 * Componente que permite registrar la dirección de un aspirante.
 * @param {object} form - Hooks del useForm
 * @return {JSX.Element}
 */
export const DatosContacto = ({ form }) => {
  const dispatch = useDispatch();
  //State-redux
  const { isConsulta } = useSelector((state) => state.aspirante.consulta);
  const { aspiranteById } = useSelector((state) => state.aspirante);
  const { estados, municipios, medios } = useSelector(
    (state) => state.catalogos
  );

  //useEffect que carga el catalogo de estados
  useEffect(() => {
    if (isConsulta && aspiranteById.idEstado) {
      dispatch(catDuck.getCatMunicipios(aspiranteById.idEstado)); //Se cargan los municipios
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConsulta]);

  /**
   * Función que recupera el texto del estado a partir del id
   * @param {number} id
   * @return {string} El nombre del estado
   */
  const getTextEstado = (id) =>
    estados.find(({ idEstado }) => idEstado === id)?.nombreEstado;

  /**
   * Función que recupera el texto del municipio a partir del id
   * @param {number} id
   * @return {string} El nombre del municipio
   */
  const getTextMunicipio = (id) =>
    municipios.find(({ idMunicipio }) => idMunicipio === id)?.nombreMunicipio;

  const getTextMedios = (idMedio) =>
    medios.find(({ id }) => id === idMedio)?.nombre;

  /**
   *Función que obtiene la lista de municipios de acuerdo al idEstado
   * @param {number} value : idEstado
   */
  const onChangeEstado = (value) => {
    form.setFieldsValue({ idMunicipio: undefined }); //Se limpia el Select Municipio
    if (value) {
      dispatch(catDuck.getCatMunicipios(value)); //Se cargan los municipios
    } else {
      dispatch(catDuck.setCatMunicipios([]));
    }
  };

  return (
    <>
      <Row gutter={24}>
        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            label={
              <Label label={"Estado"} isConsulta={isConsulta} isRequired />
            }
            name="idEstado"
            initialValue={aspiranteById.idEstado}
            rules={REQUERIDO}
          >
            {isConsulta ? (
              <div className="consulta-div">
                {getTextEstado(aspiranteById.idEstado)}
              </div>
            ) : (
              <Select
                showSearch
                allowClear
                onChange={(value) => onChangeEstado(value)}
                optionFilterProp="children"
                placeholder={"Selecciona una opción"}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {estados.map(({ idEstado, nombreEstado }) => (
                  <Select.Option key={idEstado} value={idEstado}>
                    {nombreEstado}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            label={
              <Label
                label={"Municipio/alcaldía"}
                isConsulta={isConsulta}
                isRequired
              />
            }
            name="idMunicipio"
            initialValue={aspiranteById.idMunicipio}
            rules={REQUERIDO}
          >
            {isConsulta ? (
              <div className="consulta-div">
                {getTextMunicipio(aspiranteById.idMunicipio)}
              </div>
            ) : (
              <Select
                showSearch
                allowClear
                optionFilterProp="children"
                placeholder={"Selecciona una opción"}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {municipios.map(({ idMunicipio, nombreMunicipio }) => (
                  <Select.Option key={idMunicipio} value={idMunicipio}>
                    {nombreMunicipio}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            label={<Label label={"Localidad"} isConsulta={isConsulta} />}
            name="localidad"
            rules={DIRECCION}
            initialValue={aspiranteById.localidad}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.localidad}</div>
            ) : (
              <Input maxLength={80} {...props} />
            )}
          </Form.Item>
        </Col>
      </Row>

      {/* ----------------------- Calle ------------------------------------------ */}
      <Row gutter={24}>
        <Col span={16} xxl={16} xl={16} lg={16} md={16} sm={24} xs={24}>
          <Form.Item
            label={<Label label={"Calle"} isConsulta={isConsulta} isRequired />}
            name="calle"
            rules={[...DIRECCION, ...REQUERIDO]}
            initialValue={aspiranteById.calle}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.calle}</div>
            ) : (
              <Input maxLength={maxValue.MAX_CALLE} {...props} />
            )}
          </Form.Item>
        </Col>

        <Col span={4} xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
          <Form.Item
            label={
              <Label
                label={"No. exterior"}
                isConsulta={isConsulta}
                isRequired
              />
            }
            name="noExterior"
            rules={[...DIRECCION, ...REQUERIDO]}
            initialValue={aspiranteById.noExterior}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.noExterior}</div>
            ) : (
              <Input maxLength={10} {...props} />
            )}
          </Form.Item>
        </Col>
        <Col span={4} xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
          <Form.Item
            label={<Label label={"No. interior"} isConsulta={isConsulta} />}
            name="noInterior"
            rules={DIRECCION}
            initialValue={aspiranteById.noInterior}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.noInterior}</div>
            ) : (
              <Input maxLength={10} {...props} />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={16} xxl={16} xl={16} lg={16} md={16} sm={24} xs={24}>
          <Form.Item
            label={
              <Label label={"Colonia"} isConsulta={isConsulta} isRequired />
            }
            name="colonia"
            rules={[...DIRECCION, ...REQUERIDO]}
            initialValue={aspiranteById.colonia}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.colonia}</div>
            ) : (
              <Input maxLength={maxValue.MAX_COLONIA} {...props} />
            )}
          </Form.Item>
        </Col>
        <Col span={4} xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
          <Form.Item
            label={
              <Label
                label={"Código Postal"}
                isConsulta={isConsulta}
                isRequired
              />
            }
            name="codigoPostal"
            rules={CP}
            initialValue={aspiranteById.codigoPostal}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.codigoPostal}</div>
            ) : (
              <Input maxLength={5} {...props} />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Divider />
      <h2>Información de contacto</h2>

      {!isConsulta && <AlertGeneric type="info" message={INFO_TEL} />}

      <Row gutter={24}>
        <Col span={6} xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
          <Form.Item
            label={
              <Label
                label={`Teléfono de contacto principal ${INFO_TEL_10}`}
                isConsulta={isConsulta}
                isRequired
              />
            }
            name="telMovil"
            rules={[...TELEFONO, ...REQUERIDO]}
            initialValue={aspiranteById.telMovil}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.telMovil}</div>
            ) : (
              <Input maxLength={10} {...props} />
            )}
          </Form.Item>
        </Col>
        <Col span={7} xxl={7} xl={7} lg={7} md={7} sm={24} xs={24}>
          <Form.Item
            label={
              <Label
                label={`Teléfono de contacto secundario ${INFO_TEL_10}`}
                isConsulta={isConsulta}
                isRequired
              />
            }
            name="telParticular"
            rules={[...TELEFONO, ...REQUERIDO]}
            initialValue={aspiranteById.telParticular}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.telParticular}</div>
            ) : (
              <Input maxLength={10} {...props} />
            )}
          </Form.Item>
        </Col>
        <Col span={11} xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
          <Form.Item
            label={
              <Label
                label="¿Cuál fue el medio de difusión por el que se enteró del Concurso Público?"
                isConsulta={isConsulta}
                isRequired
              />
            }
            name="idMedio"
            initialValue={aspiranteById.idMedio}
            rules={REQUERIDO}
          >
            {isConsulta ? (
              <div className="consulta-div">
                {getTextMedios(aspiranteById.idMedio)}
              </div>
            ) : (
              <Select
                showSearch
                allowClear
                optionFilterProp="children"
                placeholder={"Selecciona una opción"}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {medios.map(({ id, nombre }) => (
                  <Select.Option key={id} value={id}>
                    {nombre}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
